import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Transform } from './Transform.js';
import { Mat3 } from '../math/Mat3.js';
import { Mat4 } from '../math/Mat4.js';
var ID = 0;
export var Mesh = /*#__PURE__*/function (_Transform) {
  _inherits(Mesh, _Transform);

  var _super = _createSuper(Mesh);

  function Mesh(gl) {
    var _this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        geometry = _ref.geometry,
        program = _ref.program,
        _ref$mode = _ref.mode,
        mode = _ref$mode === void 0 ? gl.TRIANGLES : _ref$mode,
        _ref$frustumCulled = _ref.frustumCulled,
        frustumCulled = _ref$frustumCulled === void 0 ? true : _ref$frustumCulled,
        _ref$renderOrder = _ref.renderOrder,
        renderOrder = _ref$renderOrder === void 0 ? 0 : _ref$renderOrder;

    _classCallCheck(this, Mesh);

    _this = _super.call(this);
    _this.gl = gl;
    _this.id = ID++;
    _this.geometry = geometry;
    _this.program = program;
    _this.mode = mode; // Used to skip frustum culling

    _this.frustumCulled = frustumCulled; // Override sorting to force an order

    _this.renderOrder = renderOrder;
    _this.modelViewMatrix = new Mat4();
    _this.normalMatrix = new Mat3();
    _this.beforeRenderCallbacks = [];
    _this.afterRenderCallbacks = [];
    return _this;
  }

  _createClass(Mesh, [{
    key: "onBeforeRender",
    value: function onBeforeRender(f) {
      this.beforeRenderCallbacks.push(f);
      return this;
    }
  }, {
    key: "onAfterRender",
    value: function onAfterRender(f) {
      this.afterRenderCallbacks.push(f);
      return this;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          camera = _ref2.camera;

      this.beforeRenderCallbacks.forEach(function (f) {
        return f && f({
          mesh: _this2,
          camera: camera
        });
      }); // Set the matrix uniforms

      if (camera) {
        // Add empty matrix uniforms to program if unset
        if (!this.program.uniforms.modelMatrix) {
          Object.assign(this.program.uniforms, {
            modelMatrix: {
              value: null
            },
            viewMatrix: {
              value: null
            },
            modelViewMatrix: {
              value: null
            },
            normalMatrix: {
              value: null
            },
            projectionMatrix: {
              value: null
            },
            cameraPosition: {
              value: null
            }
          });
        }

        this.program.uniforms.projectionMatrix.value = camera.projectionMatrix;
        this.program.uniforms.cameraPosition.value = camera.worldPosition;
        this.program.uniforms.viewMatrix.value = camera.viewMatrix;
        this.modelViewMatrix.multiply(camera.viewMatrix, this.worldMatrix);
        this.normalMatrix.getNormalMatrix(this.modelViewMatrix);
        this.program.uniforms.modelMatrix.value = this.worldMatrix;
        this.program.uniforms.modelViewMatrix.value = this.modelViewMatrix;
        this.program.uniforms.normalMatrix.value = this.normalMatrix;
      } // determine if faces need to be flipped - when mesh scaled negatively


      var flipFaces = this.program.cullFace && this.worldMatrix.determinant() < 0;
      this.program.use({
        flipFaces: flipFaces
      });
      this.geometry.draw({
        mode: this.mode,
        program: this.program
      });
      this.afterRenderCallbacks.forEach(function (f) {
        return f && f({
          mesh: _this2,
          camera: camera
        });
      });
    }
  }]);

  return Mesh;
}(Transform);